import IdentifyApi from '@apis/auth/IdentifyApi';
import useLoading from '@hooks/ui/useLoading';
import useProjectId from '@hooks/useProjectId';
import { useMutation } from '@tanstack/react-query';
import { handleIdentificationSuccess } from '@utils/utils';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

/** PIN 재설정을 위한 본인인증을 요청하고 인증 화면으로 넘긴다 */
function useIdentifyForEasyCardPin() {
    const { t } = useTranslation('easyCard');
    const { startLoading, stopLoading } = useLoading();
    const projectId = useProjectId();
    const { mutate } = useMutation({
        mutationFn: IdentifyApi.identifyForEasyCardPin,
        onSuccess: handleIdentificationSuccess,
        onMutate() {
            startLoading();
        },
        onError(e) {
            console.error(e);
            toast.error(t('pin.reset.identifyError'));
        },
        onSettled() {
            stopLoading();
        },
    });

    const handleIdentity = () => {
        mutate(projectId);
    };

    return {
        handleIdentity,
    };
}

export default useIdentifyForEasyCardPin;
